"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Box_1 = require("@nerdwallet/currency/components/Box");
var Button_1 = require("@nerdwallet/currency/components/Button");
var Link_1 = require("@nerdwallet/currency/components/Link");
var Modal_1 = require("@nerdwallet/currency/components/Modal");
var Text_1 = require("@nerdwallet/currency/components/Text");
var Title_1 = require("@nerdwallet/currency/components/Title");
var constants_1 = require("../../utils/constants");
var local_storage_1 = __importDefault(require("../../utils/local-storage"));
var session_storage_1 = __importDefault(require("../../utils/session-storage"));
var classnames_1 = __importDefault(require("classnames"));
var painted_door_modal_module_css_1 = __importDefault(require("./painted-door-modal.module.css"));
var PaintedDoorModal = function (_a) {
    var featuredBackgroundImage = _a.featuredBackgroundImage, _b = _a.featuredImage, featuredImage = _b === void 0 ? "".concat(constants_1.CDN_URL, "/nerdwallet-plus/illustration-objects.svg") : _b, _c = _a.featuredImageHeight, featuredImageHeight = _c === void 0 ? "254px" : _c, onClickPrimaryButton = _a.onClickPrimaryButton, onClickSecondaryButton = _a.onClickSecondaryButton, onClose = _a.onClose, localStorageKey = _a.localStorageKey, primaryButtonText = _a.primaryButtonText, secondaryButtonText = _a.secondaryButtonText, sessionStorageKey = _a.sessionStorageKey, buttonsContainerClassName = _a.buttonsContainerClassName, containerClassName = _a.containerClassName, contentClassName = _a.contentClassName, modalClassName = _a.modalClassName, subtitle = _a.subtitle, title = _a.title;
    var _d = (0, react_1.useState)(true), isOpen = _d[0], setIsOpen = _d[1];
    var sessionStorage = (0, session_storage_1.default)();
    var localStorage = (0, local_storage_1.default)();
    (0, react_1.useEffect)(function () {
        sessionStorage.setItem(sessionStorageKey, "true");
    }, []);
    var handleClickPrimaryButton = (0, react_1.useCallback)(function () {
        if (onClickPrimaryButton) {
            onClickPrimaryButton();
        }
        localStorage.setItem(localStorageKey, true);
        setIsOpen(false);
    }, [onClickPrimaryButton]);
    var handleClickSecondaryButton = (0, react_1.useCallback)(function () {
        if (onClickSecondaryButton) {
            onClickSecondaryButton();
        }
        localStorage.setItem(localStorageKey, true);
        setIsOpen(false);
    }, [onClickSecondaryButton]);
    var handleClose = function () {
        if (onClose) {
            onClose();
            setIsOpen(false);
        }
    };
    var renderHeader = function () {
        if (featuredImage && featuredBackgroundImage) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: painted_door_modal_module_css_1.default.featuredBackgroundImage, style: {
                        backgroundImage: "url(".concat(featuredBackgroundImage, ")"),
                    } }),
                react_1.default.createElement(Box_1.Box, { className: painted_door_modal_module_css_1.default.featuredImage },
                    react_1.default.createElement("img", { src: featuredImage, height: featuredImageHeight }))));
        }
        if (featuredImage) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: painted_door_modal_module_css_1.default.defaultBackground },
                    react_1.default.createElement("div", { className: painted_door_modal_module_css_1.default.lime })),
                react_1.default.createElement(Box_1.Box, { className: painted_door_modal_module_css_1.default.featuredImage },
                    react_1.default.createElement("img", { src: featuredImage, height: featuredImageHeight }))));
        }
        return null;
    };
    return (react_1.default.createElement(Modal_1.Modal, { isOpen: isOpen, className: (0, classnames_1.default)(painted_door_modal_module_css_1.default.modalOverride, modalClassName), onRequestClose: handleClose },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(painted_door_modal_module_css_1.default.container, containerClassName) },
            react_1.default.createElement(Box_1.Box, { display: "flex", flexDirection: "column", alignItems: "center", height: 100 },
                renderHeader(),
                react_1.default.createElement(Box_1.Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", height: 100, className: (0, classnames_1.default)(painted_door_modal_module_css_1.default.content, contentClassName) },
                    react_1.default.createElement(Box_1.Box, { className: painted_door_modal_module_css_1.default.copyContainer, display: "flex", flexDirection: "column", alignItems: "center" },
                        title ? (react_1.default.createElement(Box_1.Box, { marginTop: { desktop: 3, mobile: 5 }, marginBottom: "3" },
                            react_1.default.createElement(Title_1.Title, { align: "center", size: "small" }, title))) : null,
                        subtitle ? (react_1.default.createElement(Box_1.Box, { marginBottom: 4 },
                            react_1.default.createElement(Text_1.Text, { align: "center", component: "p", light: true }, subtitle))) : null),
                    react_1.default.createElement(Box_1.Box, { width: "100", className: (0, classnames_1.default)(painted_door_modal_module_css_1.default.buttonsContainer, buttonsContainerClassName) },
                        react_1.default.createElement(Button_1.Button, { primary: true, block: true, onClick: handleClickPrimaryButton }, primaryButtonText),
                        secondaryButtonText && handleClickSecondaryButton ? (react_1.default.createElement(Box_1.Box, { marginTop: 3 },
                            react_1.default.createElement(Text_1.Text, { align: "center", component: "p" },
                                react_1.default.createElement(Link_1.Link, { onClick: handleClickSecondaryButton }, secondaryButtonText)))) : null))))));
};
exports.default = PaintedDoorModal;
